/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export enum ResourceSelectorMode {
  RESOURCE_SELECTOR_MODE_ALL = 'ALL',
  RESOURCE_SELECTOR_MODE_NONE = 'NONE',
  RESOURCE_SELECTOR_MODE_CONDITIONAL = 'CONDITIONAL'
}
